/**
 * Configuration options, see .env.sample for explanation
 */
import log from 'loglevel';

const getCSRF = () => {
  const cookie = document.cookie.split(/;/)
    .map(item => item.trim())
    .filter(item => item.match(/^csrftoken=/))
    .map(item => item.split(/=/, 2))[0]

  return cookie ? cookie[1] : null;
}

const siteConfig = window.SITE_CONFIG || {};
const siteRecipe = siteConfig.RECIPE || {};

export const baseURL = siteConfig.BASE_URL || process.env.VUE_APP_BASE_URL || 'https://apibakery.com';
export const logLevel = siteConfig.LOG_LEVEL || process.env.VUE_APP_LOG_LEVEL || log.levels.INFO;
export const defaultPlatform = process.env.VUE_APP_PLATFORM || '';
export const isDemo = !siteConfig.GENERATE_URL;
export const isRegisteredUser = !!siteConfig.IS_REGISTERED_USER;
/**
 * Project details may have been changed since recipe was last stored
 * so we update name and description if needed. Project platform never
 * changes but at the start, the recipe dict will be empty so we need
 * to set it.
 */
export const defaultRecipe = {
  ...siteRecipe,
  name: siteConfig.PROJECT_NAME || siteRecipe.name,
  description: siteConfig.PROJECT_DESCRIPTION || siteRecipe.description,
  platform: siteRecipe.platform || siteConfig.PROJECT_PLATFORM || defaultPlatform,
};

export const csrfToken = getCSRF();
export const saveUrl = siteConfig.RECIPE_SAVE_URL || process.env.VUE_APP_SAVE_URL || '';
export const projectUrl = siteConfig.PROJECT_URL || '';

export const generateUrl = (
  siteConfig.GENERATE_URL && siteConfig.PROJECT_REVISION ?
    `${siteConfig.GENERATE_URL}?rev=${siteConfig.PROJECT_REVISION}` :
    (process.env.VUE_APP_GENERATE_URL || '')
);
